
import request from '@/request'
const part_url = 'system/web/system/';

function getDicByCode(data) {
    let url = part_url+"getDicByCode";
    return request.get(url, data)
}




export default {
    getDicByCode
}



// WEBPACK FOOTER //
// ./src/api/system.js